import { Component, OnInit } from '@angular/core';
import { FooterService } from '../../components/footer/footer.service';
import { CommonService } from '../../shared/common.service';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { StorageKey, StorageService } from '../../shared/storage.service';

@Component({
  selector: 'app-redirect-faq',
    templateUrl: './government-travel-advice.component.html',
    styleUrls: ['./government-travel-advice.component.css']
})
export class GovernmentTravelAdvice implements OnInit {
  faqs: any[] = [];
  errorMessage: string = '';

  constructor(
    private footerService: FooterService,
    public commonService: CommonService,
    public userLayoutService: UserLayoutService,
    public storageService: StorageService,
  ) { }

  ngOnInit(): void {
    
    this.footerService.hideFooter();
    

    
  }


  toggleContent(index: number): void {
    this.faqs[index].isOpen = !this.faqs[index].isOpen;
  }

}
